{
  "version": 1,
  "asset_id": "f0fc5d72-a12f-4911-8acf-7c7362a4c59c",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f0fc5d72-a12f-4911-8acf-7c7362a4c59c/ind-legal-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f0fc5d72-a12f-4911-8acf-7c7362a4c59c/ind-legal-640.avif",
  "original_filename": "ind-legal-640.avif",
  "size": 4427,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:05Z"
}
